/** Outbound ZoeHub events; do not also subscribe to the legacy broadcastAlert event. */
export const ClientEvents = {
    ALERT: 'alert',
    ENTITY_CHANGED: 'entityChanged',
    GENERIC_MESSAGE: 'genericMessage',
} as const;
